const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

function syncProductInformationTitle() {
  const productTitle = document.querySelector('product-info .product__title h1');
  const productInformationTitle = document.querySelector('.product-inform .section-header-wrapper .sub-heading');

  if (!productTitle || !productInformationTitle) return;

  const title = productTitle.textContent.trim();
  if (title && productInformationTitle.textContent.trim() !== title) {
    productInformationTitle.textContent = title;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncProductInformationTitle);
} else {
  syncProductInformationTitle();
}

document.addEventListener('shopify:section:load', syncProductInformationTitle);
